import Styles from './Background.module.scss'
export const Background = () => <div className={Styles.background} />
